import script from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClientUploadsDialog.vue?vue&type=style&index=0&id=575c3ac2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575c3ac2"]])

export default __exports__